

export default {
    namespaced:true,
    state: {
        isRefreshing:false,
        /**存储请求体 */
        requests:[],
        /**message实例 */
        messageCase:null,
        /**html当前的fontsize */
        htmlFontSize:10
    },
    mutations: {
       changeRefresh(state,value){
        state.isRefreshing=value;
       },
       /**修改message实例 */
       changeMessageCase(state,value){
        state.messageCase=value;
       },
       /**添加请求 */
       addRequest(state,data){
        state.requests.push(data);
       },
       /**清空请求体 */
       clearRequest(state){
        state.requests=[];
       },
       /**修改html的fontsize */
       changeFontSize(state,value){
        state.htmlFontSize=value;
       }
    },
    actions: {
       
    }
};